(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rwrr-testimonial-slider"] && !Shopify.designMode) return;
  try {
    
const slider = new Swiper('.rwrr-slider', {
  slidesPerView: 1.3,
  spaceBetween: 20,
  navigation: {
    nextEl: '.rwrr-next',
    prevEl: '.rwrr-prev',
  },
  breakpoints: {
    390: { slidesPerView: 1.8 },
    575: { slidesPerView: 2.5 },
    768: { slidesPerView: 3 },
    1200: { slidesPerView: 4 }
  }
});

const videoBoxes = document.querySelectorAll('.rwrr-video-box');

videoBoxes.forEach(box => {
  const video = box.querySelector('video');
  const playBtn = box.querySelector('.rwrr-play-btn');

  /* Play Button Click */
  playBtn.addEventListener('click', () => {
    pauseAllVideos(video);

    video.play();
    playBtn.style.display = 'none';
  });

  box.addEventListener('click', () => {
    if (video.paused) {
      pauseAllVideos(video);
      video.play();
      playBtn.style.display = 'none';
    } else {
      video.pause();
      playBtn.style.display = 'flex';
    }
  });

  video.addEventListener('pause', () => {
    playBtn.style.display = 'flex';
  });
});

function pauseAllVideos(currentVideo) {
  document.querySelectorAll('.rwrr-video-box video').forEach(v => {
    if (v !== currentVideo) {
      v.pause();
      v.parentElement.querySelector('.rwrr-play-btn').style.display = 'flex';
    }
  });


        var videoElements = document.querySelectorAll('.rwrr-video-box');
    var arrowElements = document.querySelectorAll('.user-arrow');

    videoElements.forEach(function (videoEl, index) {
      var arrowEl = arrowElements[index];
      if (arrowEl) {
        var videoHeight = videoEl.offsetHeight;
        var topValue = videoHeight / 2;
        arrowEl.style.top = topValue + 'px';
      }
    });
}
    var videoElements = document.querySelectorAll('.rwrr-video-box');
    var arrowElements = document.querySelectorAll('.js_top');

    videoElements.forEach(function (videoEl, index) {
      var arrowEl = arrowElements[index];
      if (arrowEl) {
        var videoHeight = videoEl.offsetHeight;
        var topValue = videoHeight / 2;
        arrowEl.style.top = topValue + 'px';
      }
    });

  } catch(e) { console.error(e); }
})();
})();
